import { commonUtils } from '@sato/components';

import { DEFAULT_LOCALE, localesMap } from '@constants';
import { LanguageKey, LANGUAGES } from '@models/Language';
import { TranslatorFn } from '@stores/localization';

export const localizeNumber = (
  value: number | null,
  language: LanguageKey | undefined,
  options: Intl.NumberFormatOptions = {}
) => {
  const locale = languageToLocale(language);
  const locales = [locale, 'fi-FI'].filter(commonUtils.nonNullable);
  const number = Number(value);

  // to support legacy implementation where any value type was allowed
  if (!value || isNaN(number)) {
    return value?.toString();
  }

  return new Intl.NumberFormat(locales, options).format(number);
};

export const localizeDate = (
  date: Date,
  language: LanguageKey | undefined,
  options: Intl.DateTimeFormatOptions = {}
) => {
  const locale = languageToLocale(language);
  const locales = [locale, DEFAULT_LOCALE.locale].filter(
    commonUtils.nonNullable
  );

  return new Intl.DateTimeFormat(locales, options).format(date);
};

export const languageToLocale = (lang: LanguageKey | undefined) =>
  lang ? localesMap[lang].locale : undefined;

export const translateBoolean = (bool: boolean, t: TranslatorFn) =>
  t(bool ? 'yes' : 'no');

export const isValidLanguage = (
  language?: string | null
): language is LanguageKey => LANGUAGES.some((lang) => lang === language);
